import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import MuiDialogActions from '@mui/material/DialogActions';
import { Button } from '@famly/mf_input_button';
import { useTranslation } from '@famly/mf_util_translation';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
import { modalPrimaryActionProps } from '@famly/mf_modals-dialogs_modal';
import { DialogTestAttributes } from './dialog-test-attributes';
/**
 * A combined element that will show the dialog's actionable buttons on the bottom.
 *
 * Shows either a primary or delete button, depending on the given variant.
 *
 * The confirm button is the action the dialog's `Cmd`/`Ctrl` + `Enter` shortcut triggers.
 */
export const DialogButtons = (props) => {
    var _a;
    const { isScrollable, isScrolledToBottom, cancelText, confirmText, variant = 'primary', confirmIcon, onClose, onConfirm, isConfirmDisabled = false, hideCancelButton = false, } = props;
    const cancelTranslation = useTranslation('Dialog.cancel');
    const confirmTranslation = useTranslation('Dialog.confirm');
    const { isTabletPortraitAndLarger } = useBreakpoints();
    const [loading, setLoading] = React.useState(false);
    const handleClose = React.useCallback(() => onClose(), [onClose]);
    const handleConfirm = React.useCallback(() => {
        const result = onConfirm();
        if (result && typeof result.then === 'function') {
            setLoading(() => true);
            result.then(() => setLoading(() => false));
        }
    }, [onConfirm]);
    return (_jsxs(MuiDialogActions, { sx: {
            boxSizing: 'border-box',
            width: '100%',
            marginX: 0,
            marginBottom: 6,
            paddingX: 6,
            paddingTop: 4,
            paddingBottom: 0,
            justifyContent: {
                base: 'stretch',
                mobileLandscape: 'flex-end',
            },
            alignItems: {
                base: 'stretch',
                mobileLandscape: 'center',
            },
            '& > :not(:first-of-type)': {
                marginLeft: 0,
            },
            gap: {
                base: 4,
                mobileLandscape: 2,
            },
            flexDirection: {
                base: 'column-reverse',
                mobileLandscape: 'row',
            },
            boxShadow: isScrollable && !isScrolledToBottom ? ' 0px -3px 2px 0px rgba(104, 111, 125, 0.04)' : undefined,
        }, children: [hideCancelButton ? null : (_jsx(Button, { "data-e2e-id": DialogTestAttributes.cancelButtonE2eId, size: isTabletPortraitAndLarger ? 'compact' : 'regular', onClick: handleClose, text: cancelText !== null && cancelText !== void 0 ? cancelText : cancelTranslation, variant: "tertiary", fullWidth: true })), _jsx(Button, { ...modalPrimaryActionProps, "data-e2e-id": DialogTestAttributes.confirmButtonE2eId, size: isTabletPortraitAndLarger ? 'compact' : 'regular', onClick: handleConfirm, text: confirmText !== null && confirmText !== void 0 ? confirmText : confirmTranslation, fullWidth: true, variant: variant, isLoading: loading, icon: confirmIcon !== null && confirmIcon !== void 0 ? confirmIcon : (variant === 'critical' ? 'delete' : undefined), isDisabled: isConfirmDisabled, "data-intercom-target": (_a = props['data-confirm-intercom-target']) !== null && _a !== void 0 ? _a : 'dialog-confirm-button' })] }));
};
